import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@common/components/ui/dialog"
import { formatMinutes } from "@common/lib/number"
import { minutesOf, taskReference } from "@common/lib/time-entries"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"
import { LogTimeForm } from "./-components/form/log-time-form"

export const Route = createFileRoute("/_layout/timesheet/log")({
  component: LogTimeDialog,
})

function LogTimeDialog(): React.ReactElement {
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const close = () => navigate({ to: "/timesheet", search: true })

  return (
    <Dialog open onOpenChange={(open) => !open && close()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Log time</DialogTitle>
        </DialogHeader>
        <LogTimeForm
          onLogged={(entry) => {
            showToast(
              "Time logged",
              `${formatMinutes(minutesOf([entry]))} on ${taskReference(entry.task)}.`,
              "success",
            )
            close()
          }}
          onCancel={close}
        />
      </DialogContent>
    </Dialog>
  )
}
